<nb-icon
  [icon]="icon"
  pack="fci"
  (click)="copyToken()"
  [ngStyle]="{ color: iconColor }"
  class="ml-auto cursor-pointer"
  [nbTooltip]="tooltip"
  nbTooltipTrigger="click"
  [nbTooltipDisabled]="disableTooltip"
>
</nb-icon>
